// require('dotenv').config();
import { URL } from './env';
import io from 'socket.io-client';

export default io.connect(URL);
export let token = localStorage.getItem('token');
export let userId = localStorage.getItem('userId');
export const setToken = (newToken) => token = newToken;
export const setUserId = (newUserId) => userId = newUserId;

export const setLogout = (refresh = true) => {
    token = '';
    userId = '';
    localStorage.clear("");
    sessionStorage.clear("");
    localStorage.setItem('isCookies', true);
    for (const key of ["token", "hash", "userId"]) document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    if (refresh) window.location.replace(window.origin);
};

// Helper to add shareCode headers for external user requests
const addShareCodeHeaders = (myHeaders) => {
    const currentPath = window.location.pathname;

    // Check if user is accessing via shareCode URL
    if (!currentPath.includes('/shareCode/')) return;

    // Extract shareCode and companyId from URL
    const pathParts = currentPath.split('/');
    const codeIndex = pathParts.indexOf('shareCode');
    const companyIndex = pathParts.indexOf('diligence-pack');

    if (codeIndex !== -1 && companyIndex !== -1) {
        const code = pathParts[codeIndex + 1];
        const companyId = pathParts[companyIndex + 1];
        myHeaders.append('x-share-code', code);
        myHeaders.append('x-company-id', companyId);
    }
};

export const postRequest = async (endpoint, obj, noLoader, animate, hideToast) => {
    let fileUploadAnimation;
    const spinner = document.getElementById("e1jygW4piZH1");
    if (endpoint !== '/question/saveCV' && !noLoader) spinner.classList.remove("op0");
    if (!endpoint.includes('/company/generateAIReport') && !noLoader) spinner.classList.remove("op0");
    if (endpoint == '/user/reportBug' || endpoint == '/user/updateProfile' || !noLoader) fileUploadAnimation = spinner
    if (animate === "noAnimation") fileUploadAnimation = null
    try {
        let myHeaders = new Headers();
        if (userId) myHeaders.append("id", userId);
        if (token) myHeaders.append("Authorization", `Bearer ${token}`);

        // Add shareCode headers for external users (if applicable)
        addShareCodeHeaders(myHeaders);

        const formData = new FormData();
        if ((endpoint.includes("sync") && endpoint.toLowerCase().includes("dataroom")) ||
            (endpoint == '/company/allocateFiles'))
            fileUploadAnimation && fileUploadAnimation?.classList.remove("op0");
        Object.entries(obj).forEach(arr => {
            if (arr[0] === "attachment" && obj.attachment.length) {
                fileUploadAnimation && fileUploadAnimation?.classList.remove("op0");
                for (const file of obj.attachment) formData.append("attachment", file);
            } else if (arr[0] === "files" && obj.files.length) {
                fileUploadAnimation && fileUploadAnimation?.classList.remove("op0");
                formData.append(arr[0], JSON.stringify(arr[1]));
            } else if (typeof arr[1] == "object") formData.append(arr[0], JSON.stringify(arr[1]));
            else formData.append(...arr);
        });

        let requestOptions = { method: 'POST', headers: myHeaders, body: formData, redirect: 'follow', timeout: 600000 };

        let response = await fetch(`${URL}/api${endpoint}`, requestOptions).then(response => response.json());
        // TODO: if code 401 then logout
        if (response['code'] == 401) setLogout();
        else if (response['code'] != 200 && !hideToast) {
            showMessage(response['message'])
        };

        return response;
    } catch (e) {
        console.error("*****Error in postRequest*****", e);
        showMessage('Something went wrong')
    } finally {
        if (!noLoader) spinner.classList.add('op0');
        fileUploadAnimation && fileUploadAnimation?.classList.add('op0');
    }
};

export const getRequest = (endpoint, action) => {
    return new Promise(async (resolve) => {
        const spinner = document.getElementById('e1jygW4piZH1');
        spinner.classList.remove('op0');
        try {
            let myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
            if (userId) myHeaders.append('id', userId);
            if (token) myHeaders.append('Authorization', `Bearer ${token}`);

            // Add shareCode headers for external users (if applicable)
            addShareCodeHeaders(myHeaders);

            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow',
                timeout: 600000
            };

            let response = await fetch(`${URL}/api${endpoint}`, requestOptions).then(response => response.json())
            if (response['code'] == 401 && action !== 'return-response') setLogout();
            else if (response['code'] != 200 && action == 'not-showMessage') return;
            else if (response['code'] != 200 && action == 'return-response') return resolve(response);
            else if (response['code'] != 200) return showMessage(response['message']);
            return resolve(response);

        } catch (e) {
            console.error("*****Error in getRequest*****", e);
            showMessage('Something went wrong')
        } finally {
            spinner.classList.add('op0')
        }
    });
};

export const showMessage = async message => {
    let popupTimeout;
    if (!document.getElementById('popup-message'))
        return setTimeout(() => showMessage(message), 1000);

    const popupEl = document.getElementById('popup-message');

    let timeout = 0;
    if (!popupEl.classList.toString().includes('hidden')) {
        popupEl.classList.add('hidden');
        timeout = 600;
    }
    setTimeout(() => {
        popupEl.innerText = message;
        popupEl.classList.remove('hidden');
        clearTimeout(popupTimeout);
        popupTimeout = setTimeout(() => popupEl.classList.add('hidden'), 5000);
    }, timeout);
};

export const restrictedForDevices = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobile = mobileRegex.test(userAgent)
    return isMobile
};